export default [
  {
    title: '时间',
    key: 'tdate',
    fixed: true,
    sortable: 'custom',
    type: 'basic',
    width: 76
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '激活数',
    key: 'downNum',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },
  {
    title: '注册数',
    key: 'newUserNum',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    sortable: 'custom',
    type: 'basic',
    width: 70
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    sortable: 'custom',
    type: 'basic',
    width: 98
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    type: 'basic',
    width: 82
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    type: 'basic',
    width: 82
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    sortable: 'custom',
    type: 'basic',
    width: 74
  },
  {
    title: '首日付费创角数',
    key: 'payRoleUserNum',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },
  {
    title: '首日创角付费率',
    key: 'payRoleUserRate',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },
  {
    title: '新创角累计充值金额',
    key: 'sumRecharge',
    sortable: 'custom',
    type: 'basic',
    width: 142
  },
  {
    title: '新创角累计回款率',
    key: 'sumRebateRate',
    sortable: 'custom',
    type: 'basic',
    width: 136
  },
  {
    title: '新创角累计天数',
    key: 'timeDiff',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },
  {
    title: '总流水',
    key: 'sumMoney',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },

  {
    title: '创角账号24H付费金额',
    key: 'createRole24hPayMoney',
    type: 'basic',
    sortable: 'custom',
    width: 98,
    checked: false
  },

  {
    title: '创角账号24HROI',
    key: 'createRole24hRoi',
    type: 'report',
    sortable: 'custom',
    width: 98,
    checked: false
  },
  {
    title: '1日ROI',
    key: 'createRoleRoi1d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '3日ROI',
    key: 'createRoleRoi3d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '7日ROI',
    key: 'createRoleRoi7d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '播放数',
    key: 'totalPlay',
    type: 'analysis',
    width: 58
  },
  {
    title: '有效播放数',
    key: 'validPlay',
    type: 'analysis',
    width: 72
  },
  {
    title: '有效播放率',
    key: 'validPlayRate',
    type: 'analysis',
    width: 72
  },
  {
    title: '播放完成数',
    key: 'playOver',
    type: 'analysis',
    width: 72
  },
  {
    title: '播完率',
    key: 'playOverRate',
    type: 'analysis',
    width: 58
  },
  {
    title: '3s播放率',
    key: 'playDuration3sRate',
    type: 'analysis',
    width: 66
  },
  {
    title: '25%进度播放率',
    key: 'play25FeedBreakRate',
    type: 'analysis',
    width: 96
  },
  {
    title: '50%进度播放率',
    key: 'play50FeedBreakRate',
    type: 'analysis',
    width: 96
  },
  {
    title: '75%进度播放率',
    key: 'play75FeedBreakRate',
    type: 'analysis',
    width: 96
  },
  {
    title: '平均单次播放时长(头条)',
    key: 'averagePlayTimePerPlay',
    type: 'analysis',
    width: 106
  },
  {
    title: '平均单次有效播放时长(腾讯)',
    key: 'averageValidPlayTimePerPlay',
    type: 'analysis',
    width: 106
  },
  {
    title: '分享数',
    key: 'videoShare',
    type: 'analysis',
    width: 88
  },
  {
    title: '评论数',
    key: 'videoComment',
    type: 'analysis',
    width: 88
  },
  {
    title: '点赞数',
    key: 'videoLike',
    type: 'analysis',
    width: 88
  },
  {
    title: '不感兴趣数',
    key: 'dislike',
    type: 'analysis',
    width: 88
  },
  {
    title: '新增关注数',
    key: 'follow',
    type: 'analysis',
    width: 88
  },
  {
    title: '私信数',
    key: 'messageAction',
    type: 'analysis',
    width: 88
  },
  {
    title: '举报数',
    key: 'report',
    type: 'analysis',
    width: 88
  },
  {
    title: '创角次留',
    key: 'createRoleTwoDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角3留',
    key: 'createRoleThreeDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角4留',
    key: 'createRoleFourDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角5留',
    key: 'createRoleFiveDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角6留',
    key: 'createRoleSixDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角7留',
    key: 'createRoleSevenDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角10留',
    key: 'createRoleTenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角15留',
    key: 'createRoleFifteenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角30留',
    key: 'createRoleThirtyDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角45留',
    key: 'createRole45DayRetainRate',
    type: 'report',
    show: true,
    width: 68
  },
  {
    title: '创角60留',
    key: 'createRole60DayRetainRate',
    type: 'report',
    show: true,
    width: 68
  },
  {
    title: '创角75留',
    key: 'createRole75DayRetainRate',
    type: 'report',
    show: true,
    width: 68
  },
  {
    title: '创角90留',
    key: 'createRole90DayRetainRate',
    type: 'report',
    show: true,
    width: 68
  },
  {
    title: '创角120留',
    key: 'createRole120DayRetainRate',
    type: 'report',
    show: true,
    width: 72
  },
  {
    title: '创角150留',
    key: 'createRole150DayRetainRate',
    type: 'report',
    show: true,
    width: 72
  },
  {
    title: '创角180留',
    key: 'createRole180DayRetainRate',
    type: 'report',
    show: true,
    width: 72
  },
  {
    title: '创角1日LTV',
    key: 'createRoleOneDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角2日LTV',
    key: 'createRoleTwoDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角3日LTV',
    key: 'createRoleThreeDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角4日LTV',
    key: 'createRoleFourDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角5日LTV',
    key: 'createRoleFiveDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角6日LTV',
    key: 'createRoleSixDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角7日LTV',
    key: 'createRoleSevenDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角10日LTV',
    key: 'createRoleTenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角15日LTV',
    key: 'createRoleFifteenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角30日LTV',
    key: 'createRoleThirtyDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角45日LTV',
    key: 'createRole45DayLtv',
    type: 'other',
    show: true,
    width: 82
  },
  {
    title: '创角60日LTV',
    key: 'createRole60DayLtv',
    type: 'other',
    show: true,
    width: 82
  },
  {
    title: '创角75日LTV',
    key: 'createRole75DayLtv',
    type: 'other',
    show: true,
    width: 82
  },
  {
    title: '创角90日LTV',
    key: 'createRole90DayLtv',
    type: 'other',
    show: true,
    width: 82
  },
  {
    title: '创角120日LTV',
    key: 'createRole120DayLtv',
    type: 'other',
    show: true,
    width: 92
  },
  {
    title: '创角150日LTV',
    key: 'createRole150DayLtv',
    type: 'other',
    show: true,
    width: 92
  },
  {
    title: '创角180日LTV',
    key: 'createRole180DayLtv',
    type: 'other',
    show: true,
    width: 92
  },
  {
    title: '创角付费次留',
    key: 'twoDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费3留',
    key: 'threeDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费4留',
    key: 'fourDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费5留',
    key: 'fiveDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费6留',
    key: 'sixDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费7留',
    key: 'sevenDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费10留',
    key: 'tenDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费15留',
    key: 'fifteenDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费30留',
    key: 'thirtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费45留',
    key: 'fortyFiveDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费60留',
    key: 'sixtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费75留',
    key: 'seventyFiveDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费90留',
    key: 'ninetyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费120留',
    key: 'oneHundredAndTwentyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费150留',
    key: 'oneHundredAndFiftyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费180留',
    key: 'oneHundredAndEightyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费210留',
    key: 'twoHundredAndTenDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费240留',
    key: 'twoHundredAndFortyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费270留',
    key: 'twoHundredAndSeventyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费300留',
    key: 'threeHundredDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费330留',
    key: 'threeHundredAndThirtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费360留',
    key: 'threeHundredAndSixtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  }
]
